import { defaultTenantHost } from "../../lib/env";

const storageKey = "gbo-local-tenant";

export const localTenantHosts = [
  "wolfe-propane",
  "northfield-propane",
  "rockbottom",
  "dandmpropane",
];

export function getSelectedLocalTenant(storage: Storage = window.localStorage) {
  const stored = storage.getItem(storageKey);
  if (stored && localTenantHosts.includes(stored)) return stored;

  return localTenantHosts.includes(defaultTenantHost) ? defaultTenantHost : localTenantHosts[0];
}

export function setSelectedLocalTenant(host: string, storage: Storage = window.localStorage) {
  if (!localTenantHosts.includes(host)) throw new Error(`Unknown local tenant host: ${host}`);

  storage.setItem(storageKey, host);
}
